import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var StatisticStyle = function StatisticStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    titleColor1 = _getThemeData.titleColor1;
  var _getThemeData2 = getThemeData(props, 'statistic'),
    titleFontSize = _getThemeData2.titleFontSize,
    contentFontSize = _getThemeData2.contentFontSize,
    titleLineHeight = _getThemeData2.titleLineHeight,
    contentLineHeight = _getThemeData2.contentLineHeight;
  return css([".c7n-statistic.c7n-statistic{.c7n-statistic-title{font-size:", "px;line-height:", "px;}.c7n-statistic-content{font-size:", "px;font-weight:500;line-height:", "px;color:", ";}}"], titleFontSize, titleLineHeight, contentFontSize, contentLineHeight, titleColor1);
};
export default StatisticStyle;